<p-toast [key]="toastKey" position="top-right"></p-toast>
<fieldset [ngClass]="classeModeApplication">
	<legend>{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.TITRE_LEGEND' | translate}}</legend>
	<div>
		<div>{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.MESSAGE_DIFFUSION' | translate}}
		</div>
		<button *ngIf="!modeApplicationCohabitation" pButton
				class="float-right bouton-admin btn"
				icon="pi pi-download"
				[title]="'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.TITLE_BTN_DIFFUSION' | translate"
				(click)="diffuserElementsTraduisibles()"
				[label]="'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.BTN_DIFFUSER' | translate"></button>
		<button *ngIf="modeApplicationCohabitation"
				type="button"
				class="btn btn-medium action-button pull-right"
				title="{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.TITLE_BTN_DIFFUSION' | translate}}"
				(click)="diffuserElementsTraduisibles()">
			<i class="icon-share-alt"></i>{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.BTN_DIFFUSER' | translate}}
		</button>
	</div>
</fieldset>
